import { ColSpan } from '@/components/primitives/Grid/Grid.styles';

/** Returns the ColSpan for a grid item within a 12-column layout.
 * Items in complete rows use the calculated span; overflow items fill the full row. */
export const resolveColSpan = (
  maxCountPerRow: number,
  itemIndex: number,
  items?: number
): ColSpan => {
  if (!items) return 12;
  const span = Math.floor(Math.max(12 / items, 12 / maxCountPerRow)) as ColSpan;
  if (!(items % maxCountPerRow) || itemIndex + 1 <= items - (items % maxCountPerRow)) return span;
  return (12 / (items % maxCountPerRow)) as ColSpan;
};
